/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_DunningTemplate = {
    body_html?: string;
    body_text?: string;
    created_at?: string;
    created_by?: string;
    deleted_at?: string;
    id?: string;
    is_default?: boolean;
    language?: models_DunningTemplate.language;
    org_id?: string;
    stage?: models_DunningTemplate.stage;
    subject?: string;
    updated_at?: string;
    updated_by?: string;
};
export namespace models_DunningTemplate {
    export enum language {
        EN = 'en',
        DE = 'de',
    }
    export enum stage {
        REMINDER_1 = 'reminder_1',
        REMINDER_2 = 'reminder_2',
        REMINDER_3 = 'reminder_3',
        FINAL_NOTICE = 'final_notice',
        FINAL_REPEAT = 'final_repeat',
    }
}

